import { SolidViewLayoutManager } from "@solidstarters/solid-core-ui";

const bondTransactionOnLoadHandler = async (event: any) => {
    const {viewMetadata, formData} = event;
    const layout = viewMetadata.layout;
    const layoutManager = new SolidViewLayoutManager(layout);
    
    if(formData?.type === 'Export'){
        layoutManager.updateNodeAttributes('igmNo', { "visible": false});
        layoutManager.updateNodeAttributes('igmDate', { "visible": false});
        layoutManager.updateNodeAttributes('pcNo', { "visible": true});
        layoutManager.updateNodeAttributes('pcDate', { "visible": true});
    }
    else if(formData?.type === 'Extension'){
        layoutManager.updateNodeAttributes('igmNo', { "visible": false});
        layoutManager.updateNodeAttributes('igmDate', { "visible": false});
        layoutManager.updateNodeAttributes('pcNo', { "visible": false});
        layoutManager.updateNodeAttributes('pcDate', { "visible": false});
    }
    else{
        layoutManager.updateNodeAttributes('pcNo', { "visible": false});
        layoutManager.updateNodeAttributes('pcDate', { "visible": false});
        layoutManager.updateNodeAttributes('igmNo', { "visible": true});
        layoutManager.updateNodeAttributes('igmDate', { "visible": true});
    }
    // layoutManager.updateNodeAttributes('pcNo', { "visible": false});
    // layoutManager.updateNodeAttributes('pcDate', { "visible": false});
    return {
        layoutChanged: true,
        dataChanged: false,
        newLayout: layoutManager.getLayout()
    }
}

export default bondTransactionOnLoadHandler;